import GetReportPumpingStation from "../components/PumpingStation/GetReportPumpingStation";

const GetReportPumpingStationPage = () =>{
     
    return(
          <>
            <GetReportPumpingStation/>
          </>
    )
}

export default GetReportPumpingStationPage;